import { Inline, Text, textVariants, Tooltip } from '@etg/wings';
import { useSnowplowTracking, useTranslation } from '@eti/providers';
import { InformationIconButton } from '@eti/components';
import { constants } from '@eti/utils';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';

const OrderNumber = () => {
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const { orderNumber } = useOrderDetails();

  const handleSnowplowOnOrderNrInfo = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Order Details',
        action: 'Hover',
        label: 'ORDER_NR_INFO',
      });
    }
  };

  return (
    <Inline alignY="center" spacing={4}>
      <Inline alignY="center" data-testid="order-number" spacing={4}>
        <Text>{t('OrderDetails.BookingCodes.OrderNumber.Label')} </Text>
        <Text className={constants.MOUSE_FLOW_CLASS_NAMES} variant={textVariants._14_BOLD}>
          {orderNumber}
        </Text>
      </Inline>
      <Tooltip
        content={t('OrderDetails.BookingCodes.OrderNumber.Tooltip')}
        title={t('OrderDetails.BookingCodes.OrderNumber.Label')}
      >
        <InformationIconButton
          data-testid="order-number-tooltip-icon"
          onMouseEnter={handleSnowplowOnOrderNrInfo}
        />
      </Tooltip>
    </Inline>
  );
};

export default OrderNumber;
